import styled from "styled-components";

const ImageContainer = styled.div`
  position: relative;
`;

export default ImageContainer;
